export default __webpack_public_path__ + "static/media/signup.b91ff0d4.svg";